import { default as color } from 'color';

// Styles

// RenderFunction

function SeatSpinner(props) {
	const e = props.element;

	const centerX = e.x + (e.width / 2);
	const centerY = e.y + (e.height / 2);
	const spinnerRotateFrom = `0 ${centerX} ${centerY}`;
	const spinnerRotateTo = `360 ${centerX} ${centerY}`;
	const radius = (e.width >= e.height ? e.height : e.width) / 4;
	const spinnerStrokeWidth = (e.width >= e.height ? e.height : e.width) / 10;

	const score = 0.8;
	const length = score * 2 * Math.PI * radius;
	const max = 7 * radius;
	const strokeDashArrayString = `${length} ${max}`;
	const spinnerColor = props.seatColor.startsWith("url(") ? "#000000" : color(props.seatColor).negate().grayscale();
	return (
		<g>
			<circle
				cx={centerX}
				cy={centerY}
				r={radius}
				stroke={spinnerColor}
				strokeOpacity="1"
				fillOpacity="0"
				strokeWidth={spinnerStrokeWidth}
				strokeDasharray={strokeDashArrayString}
			/>
			<animateTransform
				attributeType="xml"
				attributeName="transform"
				type="rotate"
				from={spinnerRotateFrom}
				to={spinnerRotateTo}
				dur="0.7s"
				repeatCount="indefinite"
			/>
		</g>
	);
}

export default (SeatSpinner);
